interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumbs({ items }: BreadcrumbsProps) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-sm text-foreground-600">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span key={index} className="flex items-center gap-1.5 whitespace-nowrap">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-foreground-400"></i>
            )}
            {isLast || !item.href ? (
              <span className="text-foreground-900 font-medium" aria-current="page">{item.label}</span>
            ) : (
              <Link to={item.href} className="hover:text-primary-500 transition-colors duration-200">
                {item.label}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}